import {
  ProgressCardInfoCell,
  ProgressCardView,
} from '@euler/app/tv/components/detail/ProgressCardView';
import { AbnormalLevel, SiteInspectionType } from '@euler/model/enum';
import { TaskDetail } from '@euler/model/task-detail';
import { formatDateTime } from '@euler/utils/formatters';
import { memo } from 'react';
import { StyleProp, ViewStyle } from 'react-native';

export const PreInspectionProgressView = memo(
  ({
    detail,
    style,
    onPress,
  }: {
    detail: TaskDetail;
    style?: StyleProp<ViewStyle>;
    onPress?: () => void;
  }) => {
    const defectiveFacadeCount = detail.preInspection.sites.filter(
      x =>
        x.inspectionType === SiteInspectionType.Facade &&
        x.abnormalLevel !== AbnormalLevel.Fine,
    ).length;

    const defectiveTroubleLightCount = detail.preInspection.sites.filter(
      x =>
        x.inspectionType === SiteInspectionType.Dashboard &&
        x.abnormalLevel !== AbnormalLevel.Fine,
    ).length;
    return (
      <ProgressCardView
        title="接车预检"
        status={detail.preInspection.status}
        statusButtonInProgressText={'检测中'}
        index={0}
        style={style}
        onPress={onPress}
      >
        <ProgressCardInfoCell
          label="服务顾问"
          value={detail.basicInfo.serviceAgentName}
        />
        <ProgressCardInfoCell
          label="接车时间"
          value={formatDateTime(detail.basicInfo.createdAt)}
        />
        <ProgressCardInfoCell
          label="预检结果"
          value={`${defectiveFacadeCount}外观异常/${defectiveTroubleLightCount}故障灯亮`}
        />
      </ProgressCardView>
    );
  },
);
